// Логика слотов элементов — отдельно от компонента: файл с компонентами не
// должен экспортировать ничего кроме них (react-refresh), а состояние слота и
// лента лайтбокса проверяются юнит-тестами без рендера.

import type { Element } from "~/entities/element";

/** Занят / свободен и доступен для заполнения / ещё закрыт предыдущим слотом. */
export type ElementSlotState = "filled" | "open" | "locked";

/**
 * Слоты заполняются по порядку: активен ровно один свободный — сразу за
 * последним занятым. Это тот же принцип, что у кадров (`FrameRoleSlots`), и он
 * держит ряд предсказуемым: пропуск в середине читался бы как «сюда тоже можно».
 */
export function elementSlotState(index: number, filledCount: number): ElementSlotState {
    if (index < filledCount) return "filled";
    if (index === filledCount) return "open";
    return "locked";
}

/** Превью слота — первая картинка элемента (у элемента их всегда 2-4). */
export function elementCoverUrl(element: Element): string | null {
    return element.images[0]?.s3Url ?? null;
}
